<template>
  <v-avatar
    class="zoox-component zoox-avatar"
    :size="size"
    :color="color"
    v-on="$listeners"
  >
    <img v-if="photo" v-bind="$attrs" :src="photo" :alt="name" />
    <span v-else v-bind="$attrs" class="avatar">{{ name }}</span>
  </v-avatar>
</template>

<script>
/**
 * @displayName Avatar
 */
export default {
  name: 'ZAvatar',
  props: {
    /**
     * Name of avatar
     */
    name: {
      type: String,
    },
    /**
     * When this photo is passed, image is used instead of avatar
     */
    photo: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Color of avatar
     */
    color: {
      type: String,
      required: false,
      default: 'var(--lightblue)',
    },
    /**
     * Tamanho do template em pixels
     */
    size: {
      type: [Number, String],
      default: 64,
    },
  },
  methods: {
    onClick() {
      /**
       * Emite evento quando o avatar é clicado
       */
      this.$emit('click')
    },
  },
}
</script>
